import { useEffect } from "react";

/**
 * Audit fix M6: prevent the `if (done) setTimeout(onSuccess, 1500)` pattern
 * from queuing a fresh timer on every render. Under StrictMode the previous
 * code spawned two timers per render and risked feedback loops with refetch().
 *
 * Usage: useFireOnConfirm(status === "confirmed", refetch, 1500);
 */
export function useFireOnConfirm(done: boolean, fn: () => void, delay = 1500) {
    useEffect(() => {
        if (!done) return;
        const t = setTimeout(fn, delay);
        return () => clearTimeout(t);
    }, [done, fn, delay]);
}
